import api from "./ApiConfig";
import { Apis } from "../config";
import { NotificationManager } from 'react-notifications';
import unauthService from "./unauth";

const GetAllPaymentModes = async () => {
    try {
        const result = await api.get(Apis.GetAllPaymentModes, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("payment response" , response)
        
        if (!response.success) {
            NotificationManager.error(response.data.error);
            return null;
        }
        return response.additionalData;
    } catch (error) {
        if(error.status==401){
            unauthService()
        }
        console.error('Error in GetAllPaymentModes:', error);
        NotificationManager.error('An error occurred while fetching payment modes.');
        return null;
    }
};

const AddPaymentMode = async (data) => {
    try {
        // First, check if a payment mode with the same name already exists
        const existingModesResponse = await GetAllPaymentModes();
        if (existingModesResponse) {
            const exists = existingModesResponse.some(mode => 
                mode.paymentModeName.toLowerCase() === data.paymentModeName.toLowerCase()
            );

            if (exists) {
                NotificationManager.error(`Payment mode '${data.paymentModeName}' already exists.`);
                return null; // Prevent adding if it exists
            }
        }

        // If it doesn't exist, proceed with adding the new payment mode
        const result = await api.post(Apis.GetAllPaymentModes, data, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        console.log("parsedData " , response )
        
        if (!response.success) {
            NotificationManager.error(response.data.error);
            return null;
        }

        return response;
    } catch (error) {
        if(error.status==401){
            unauthService()
        }
        NotificationManager.error('An error occurred while adding paymentmode');

        console.error('Error in AddPaymentMode:', error);
        return null;
    }
};

const UpdatePaymentMode = async (data) => {
    try {
        const result = await api.put(`${Apis.GetAllPaymentModes}`, data, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("UpdatePaymentMode response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error updating payment mode');
            return null;
        }
        // NotificationManager.success(response.message);
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while updating payment mode');
        console.error('Error in UpdatePaymentMode:', error);
        return null;
    }
};

const DeletePaymentMode = async (id) => {
    try {
        const result = await api.delete(`${Apis.GetAllPaymentModes}?id=${id}`, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("DeletePaymentMode response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error deleting payment mode');
            return null;
        }
        // NotificationManager.success(response.message);
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while deleting payment mode');
        console.error('Error in DeletePaymentMode:', error);
        return null;
    }
};

// New function to get all banks
const GetAllBanks = async () => {
    try {
        const result = await api.get(Apis.GetAllBanks, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("Banks response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error fetching banks');
            return null;
        }
        return response.additionalData;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        console.error('Error in GetAllBanks:', error);
        NotificationManager.error('An error occurred while fetching banks.');
        return null;
    }
};

// New function to add a bank
const AddBank = async (data) => {
    try {
        // Check if a bank with the same name already exists before adding
        const existingBanksResponse = await GetAllBanks();
        if (existingBanksResponse) {
            const exists = existingBanksResponse.some(bank => 
                bank.bankName.toLowerCase() === data.bankName.toLowerCase()
            );

            if (exists) {
                NotificationManager.error(`Bank '${data.bankName}' already exists.`);
                return null;
            }
        }

        const result = await api.post(Apis.GetAllBanks, data, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("AddBank response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error adding bank');
            return null;
        }
        // NotificationManager.success(response.message);
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while adding bank');
        console.error('Error in AddBank:', error);
        return null;
    }
};

// New function to update a bank
const UpdateBank = async (data) => {
    try {
        const result = await api.put(`${Apis.GetAllBanks}`, data, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("UpdateBank response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error updating bank');
            return null;
        }
        // NotificationManager.success(response.message);
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while updating bank');
        console.error('Error in UpdateBank:', error);
        return null;
    }
};

// New function to delete a bank
const DeleteBank = async (id) => {
    try {
        const result = await api.delete(`${Apis.GetAllBanks}?id=${id}`, {
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData = JSON.parse(result.data);
        let response = JSON.parse(parsedData.body);
        console.log("DeleteBank response", response);

        if (!response.success) {
            NotificationManager.error(response.data.error || 'Error deleting bank');
            return null;
        }
        // NotificationManager.success(response.message);
        return response;
    } catch (error) {
        if(error.status == 401){
            unauthService();
        }
        NotificationManager.error('An error occurred while deleting bank');
        console.error('Error in DeleteBank:', error);
        return null;
    }
};

export default {
    AddPaymentMode,
    UpdatePaymentMode,
    DeletePaymentMode,
    GetAllPaymentModes,
    GetAllBanks,
    AddBank,
    UpdateBank,
    DeleteBank
}; 